"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _OctaviHighlights = _interopRequireDefault(require("./panels/OctaviHighlights"));
var _OctaviMaps = _interopRequireDefault(require("./panels/OctaviMaps"));
var _pages = require("chaire-lib-frontend/lib/components/pages");
var _ServiceLocator = _interopRequireDefault(require("chaire-lib-common/lib/utils/ServiceLocator"));
const FullSizePanel = props => {
  const [dataSourceCollection, setDataSourceCollection] = _react.default.useState(_ServiceLocator.default.collectionManager.get('dataSources'));
  _react.default.useEffect(() => {
    const onDataSourceCollectionUpdate = () => setDataSourceCollection(_ServiceLocator.default.collectionManager.get('dataSources'));
    _ServiceLocator.default.eventManager.on('collection.update.dataSources', onDataSourceCollectionUpdate);
    return () => {
      _ServiceLocator.default.eventManager.off('collection.update.dataSources', onDataSourceCollectionUpdate);
    };
  }, []);
  if (dataSourceCollection === undefined) {
    return /*#__PURE__*/_react.default.createElement(_pages.LoadingPage, null);
  }
  return /*#__PURE__*/_react.default.createElement("section", {
    id: "tr__full-size-panel"
  }, props.activeSection === 'octaviHighlights' && /*#__PURE__*/_react.default.createElement(_OctaviHighlights.default, {
    activeSection: props.activeSection
  }), props.activeSection === 'octaviMap' && /*#__PURE__*/_react.default.createElement(_OctaviMaps.default, {
    activeSection: props.activeSection
  }));
};
var _default = exports.default = FullSizePanel;